/* global $:true */
import debug from 'debug';

import plugin from '../../lib/plugin';

const MODULE_NAME = 'date-param';
const log = debug(MODULE_NAME);

class DateParamPlugin {
	constructor(element, options) {
		this.element = element;
		this.options = options;

		log('DateParamPlugin', element);
		this.init();
	}

	init() {
		const dateStamp = new Date();
		const url = new URL(this.element.href);

		this.element.href = this.appendDateParam(url, dateStamp);
	}

	appendDateParam(url, dateStamp) {
		const paramWithDate = new URLSearchParams([
			...Array.from(url.searchParams.entries()),
			["date", dateStamp]
		]).toString();

		return new URL(`${url.origin}${url.pathname}?${paramWithDate}`);
	}
}

DateParamPlugin.DEFAULTS = {};

plugin('dateParam', DateParamPlugin);

export function exec() {
	$('[data-date-param]').dateParam();
}



// WEBPACK FOOTER //
// ./client/src/core/modules/date-param/index.js